import reducer from './reducer';

export default reducer;
export {
  loadHome,
  selectCard,
  seeMoreFaq,
  getStarted,
  loadCategoryPage,
  loadFilteredPages,
  changePagesFilter,
} from './actions';



// WEBPACK FOOTER //
// ./src/redux/modules/home/index.ts